module.exports = "<div class=\"col-md-12\">\n  <div class=\"form-group\" [formGroup]=\"group\">\n    <mat-form-field >\n        <input [formControlName]=\"config.name\" type=\"number\" matInput [placeholder]=\"config.label\">\n    </mat-form-field>\n  </div>\n</div>\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/dynamic-form/components/form-number/form-number.component.html
// module id = ./src/app/modules/shared/dynamic-form/components/form-number/form-number.component.html
// module chunks = main